<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <MeasValuePlotChartForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MeasValuePlotChartForm from '@/components/organisms/report/form/MeasValuePlotChartForm'

export default {
  name: 'MeasValuePlotChartPage',
  components: { MeasValuePlotChartForm },
}
</script>
